import { TextField, ValidateOptions } from 'payload'
import { text } from 'payload/shared'
import { MaskedFieldOptions } from '@components/(payload)/fields/text/masked'
import { FieldDefault, FieldWithouType, maskedField, validatePhone } from '@utils/fields'
import { mergeObjects } from '@utils/objects'

export const phoneMaskOptions: MaskedFieldOptions = {
  unmask: false,
  lazy: false,
  overwrite: true,
  mask: [
    { mask: '(00) 0000-0000' },
    { mask: '(00) 00000-0000' },
  ]
};

/**
 * Creates a TextField (payload-better-fields-plugin) for currency
 *
 * @param overrides
 * @param config
 * @returns
 */
export function phoneField(config: FieldWithouType<CustomPayloadField<TextField>>, options?: MaskedFieldOptions): CustomPayloadField<TextField>[] {
  const defaultConfig: FieldDefault<CustomPayloadField<TextField>> = {
    type: 'text',
    validate: (value: string, args: any) => value ? validatePhone(value) : text(value, args),
  };

  config = mergeObjects(defaultConfig, config);
  options = mergeObjects(phoneMaskOptions, options || {});

  return maskedField<CustomPayloadField<TextField>>(config, options);
}
